/* ==========================================================================
   ASURA — Favoritos

   El cliente guarda perfumes con el corazón de ASURA (tarjetas y ficha) y
   los encuentra en /pages/favoritos. Se guardan en su navegador, sin cuenta:
   siguen ahí al volver, en ese mismo celular o computadora.
     [data-asura-fav]          botón guardar/quitar (data-handle, data-nombre)
     [data-asura-fav-cuenta]   cuántos hay guardados (encabezado y menú)
     [data-asura-favoritos]    la página de favoritos: se arma aquí con los
                               datos de cada perfume (/products/<handle>.js)
   Desde la página, "Agregar al carrito" mete el perfume con su decant de
   regalo (Sorpréndeme) y abre el carrito lateral, donde se puede cambiar.

   Con la sesión iniciada, la lista también vive en su cuenta (metacampo
   asura.favoritos, impreso en snippets/header-icons.liquid) y se sube por el
   proxy de la app (/apps/asura/favoritos → servidor ASURA Favoritos):
     - la primera vez de esa cuenta en este dispositivo se juntan las dos listas
     - después gana la versión más reciente (v: fecha del último cambio)
     - sin sesión, o si el servidor no responde, todo sigue en el navegador
   Marcado: snippets/asura-favorito.liquid, sections/asura-favoritos.liquid
   Estilos: assets/asura-favoritos.css
   ========================================================================== */
(function () {
  'use strict';

  if (window.asuraFavoritos) return;
  window.asuraFavoritos = {};

  var CLAVE = 'asura:favoritos:v1';
  var DECANT = 'Decant de regalo';
  var SORPRESA = 'Sorpréndeme';
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var paginaUrl = raiz + 'pages/favoritos';
  var META = 'asura:favoritos:cuenta';
  var PROXY = raiz + 'apps/asura/favoritos';
  var MAXIMO = 300;

  /* ------------------------------------------------------------------------
     Lista guardada: [{ h: handle, t: fecha }], lo más reciente primero
     ------------------------------------------------------------------------ */
  function leer() {
    try {
      var v = JSON.parse(window.localStorage.getItem(CLAVE) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && x.h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function escribir(lista) {
    try {
      window.localStorage.setItem(CLAVE, JSON.stringify(lista));
    } catch (e) {}
  }

  function guardado(handle) {
    return leer().some(function (x) { return x.h === handle; });
  }

  function poner(handle, si, fecha) {
    var lista = leer().filter(function (x) { return x.h !== handle; });
    if (si) lista.unshift({ h: handle, t: fecha || Date.now() });
    escribir(lista);
    cambio();
    pintar();
    document.dispatchEvent(new CustomEvent('asura:favoritos', {
      detail: { handle: handle, guardado: si, total: lista.length }
    }));
    return lista;
  }

  /* ------------------------------------------------------------------------
     Cuenta del cliente
     META = { c: cliente con el que se sincronizó, v: fecha del último
              cambio de la lista local, p: hay cambios por subir }
     ------------------------------------------------------------------------ */
  var cuenta = null;
  var relojSubida = null;
  var sinServidor = false;

  function leerMeta() {
    try {
      var m = JSON.parse(window.localStorage.getItem(META) || '{}');
      return m && typeof m === 'object' ? m : {};
    } catch (e) {
      return {};
    }
  }

  function escribirMeta(m) {
    try {
      window.localStorage.setItem(META, JSON.stringify(m));
    } catch (e) {}
  }

  function datosCuenta() {
    var nodo = document.querySelector('[data-asura-fav-datos-cuenta]');
    if (!nodo) return null;
    try {
      var d = JSON.parse(nodo.textContent);
      return d && d.cliente ? d : null;
    } catch (e) {
      return null;
    }
  }

  function depurar(l) {
    var vistos = {};
    return (Array.isArray(l) ? l : []).filter(function (x) {
      if (!x || !x.h || vistos[x.h]) return false;
      vistos[x.h] = true;
      return true;
    }).map(function (x) {
      return { h: String(x.h), t: Number(x.t) || 0 };
    }).slice(0, MAXIMO);
  }

  // las dos listas juntas; si un perfume está en ambas, se queda la fecha más reciente
  function unir(a, b) {
    var por = {};
    depurar(a).concat(depurar(b)).forEach(function (x) {
      if (!por[x.h] || x.t > por[x.h].t) por[x.h] = x;
    });
    return Object.keys(por).map(function (h) { return por[h]; })
      .sort(function (x, y) { return y.t - x.t; })
      .slice(0, MAXIMO);
  }

  function mismaLista(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (x, i) { return x.h === b[i].h && x.t === b[i].t; });
  }

  function cambio() {
    var m = leerMeta();
    m.v = Math.max(Date.now(), (Number(m.v) || 0) + 1);
    if (cuenta) {
      m.c = String(cuenta.cliente);
      m.p = true;
    }
    escribirMeta(m);
    if (cuenta && !sinServidor) {
      clearTimeout(relojSubida);
      relojSubida = setTimeout(subir, 700);
    }
  }

  function adoptar(guardada) {
    escribir(depurar(guardada.l));
    escribirMeta({ c: String(cuenta.cliente), v: Number(guardada.v) || 0, p: false });
    pintar();
    document.querySelectorAll('[data-asura-favoritos]').forEach(armarPagina);
  }

  function subir() {
    clearTimeout(relojSubida);
    relojSubida = null;
    if (!cuenta || sinServidor) return;
    var m = leerMeta();
    var enviada = Number(m.v) || Date.now();

    fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ v: enviada, l: leer() })
    }).then(function (r) {
      // sin app conectada todavía: se queda en el navegador
      if (r.status === 404) {
        sinServidor = true;
        return null;
      }
      return r.json().catch(function () { return null; });
    }).then(function (d) {
      if (!d || !d.ok) return;
      if (d.guardado) {
        var ahora = leerMeta();
        // si hubo otro cambio mientras viajaba, sigue pendiente y se sube después
        if (Number(ahora.v) === enviada) {
          ahora.p = false;
          escribirMeta(ahora);
        }
      } else if (d.favoritos && Array.isArray(d.favoritos.l)) {
        // otro dispositivo guardó algo más reciente
        adoptar(d.favoritos);
      }
    }).catch(function () {});
  }

  function sincronizar() {
    cuenta = datosCuenta();
    if (!cuenta) return;

    var guardada = cuenta.favoritos && Array.isArray(cuenta.favoritos.l) ? cuenta.favoritos : null;
    var vCuenta = guardada ? Number(guardada.v) || 0 : 0;
    var m = leerMeta();
    var vLocal = Number(m.v) || 0;

    if (String(m.c || '') !== String(cuenta.cliente)) {
      // primera vez de esta cuenta en este dispositivo: se juntan
      var unida = unir(leer(), guardada ? guardada.l : []);
      escribir(unida);
      if (guardada && mismaLista(unida, depurar(guardada.l))) {
        escribirMeta({ c: String(cuenta.cliente), v: vCuenta, p: false });
      } else {
        escribirMeta({ c: String(cuenta.cliente), v: Math.max(Date.now(), vCuenta + 1), p: true });
        subir();
      }
      return;
    }

    if (m.p || vLocal > vCuenta) {
      subir();
    } else if (vCuenta > vLocal) {
      escribir(depurar(guardada.l));
      escribirMeta({ c: String(cuenta.cliente), v: vCuenta, p: false });
    }
  }

  // si se va de la página con un cambio por subir, se manda antes
  window.addEventListener('pagehide', function () {
    if (relojSubida) subir();
  });

  /* ------------------------------------------------------------------------
     Botones y contadores
     ------------------------------------------------------------------------ */
  function pintar() {
    var lista = leer();
    var hay = {};
    lista.forEach(function (x) { hay[x.h] = true; });

    document.querySelectorAll('[data-asura-fav]').forEach(function (b) {
      var si = !!hay[b.dataset.handle];
      var nombre = b.dataset.nombre || 'este perfume';
      b.classList.toggle('is-guardado', si);
      b.setAttribute('aria-pressed', si ? 'true' : 'false');
      b.setAttribute('aria-label', si ? 'Quitar ' + nombre + ' de favoritos' : 'Guardar ' + nombre + ' en favoritos');
      if (b.hasAttribute('title')) b.title = si ? 'Quitar de favoritos' : 'Guardar en favoritos';
      var texto = b.querySelector('[data-asura-fav-texto]');
      if (texto) texto.textContent = si ? 'Guardado en favoritos' : 'Guardar en favoritos';
    });

    document.querySelectorAll('[data-asura-fav-cuenta]').forEach(function (c) {
      c.textContent = lista.length;
      c.hidden = lista.length === 0;
    });
  }

  /* ------------------------------------------------------------------------
     Aviso abajo: "Guardado en favoritos · Ver" / "Quitado · Deshacer"
     ------------------------------------------------------------------------ */
  var aviso = null;
  var avisoReloj = null;

  function avisar(texto, accion, alTocar) {
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'asura-fav-aviso';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      aviso.innerHTML = '<span class="asura-fav-aviso__texto"></span><a class="asura-fav-aviso__accion" href="' + paginaUrl + '"></a>';
      document.body.appendChild(aviso);
    }
    aviso.querySelector('.asura-fav-aviso__texto').textContent = texto;
    var a = aviso.querySelector('.asura-fav-aviso__accion');
    a.textContent = accion;
    a.hidden = !accion;
    a.onclick = alTocar ? function (e) { e.preventDefault(); alTocar(); ocultar(); } : null;
    aviso.classList.add('is-visible');
    clearTimeout(avisoReloj);
    avisoReloj = setTimeout(ocultar, 3200);
  }

  function ocultar() {
    if (aviso) aviso.classList.remove('is-visible');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-asura-fav]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = b.dataset.handle;
    if (!handle) return;
    var antes = leer().filter(function (x) { return x.h === handle; })[0];
    var si = !antes;
    poner(handle, si);

    b.classList.remove('is-latido');
    void b.offsetWidth;
    if (si) b.classList.add('is-latido');

    var enPagina = b.closest('[data-asura-favoritos]');
    if (si) {
      if (!enPagina) avisar('Guardado en tus favoritos', 'Ver favoritos');
    } else {
      avisar('Quitado de tus favoritos', 'Deshacer', function () {
        poner(handle, true, antes && antes.t);
        if (enPagina) armarPagina(enPagina);
      });
      if (enPagina) quitarTarjeta(enPagina, handle);
    }
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key === CLAVE) {
      pintar();
      document.querySelectorAll('[data-asura-favoritos]').forEach(armarPagina);
    }
  });

  window.addEventListener('pageshow', pintar);

  /* ------------------------------------------------------------------------
     Página de favoritos
     ------------------------------------------------------------------------ */
  function escapar(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function dinero(centavos) {
    var n = (Number(centavos) || 0) / 100;
    return '$ ' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function foto(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }

  function presentacion(etiquetas) {
    var t = (etiquetas || []).map(function (x) { return String(x).toLowerCase().trim(); });
    if (t.indexOf('parcial') > -1 || t.indexOf('parciales') > -1) return { clase: 'parcial', texto: 'Parcial' };
    if (t.indexOf('tester') > -1 || t.indexOf('testers') > -1) return { clase: 'tester', texto: 'Tester' };
    return { clase: 'linea', texto: 'De línea' };
  }

  function corazon(caja) {
    var plantilla = caja.querySelector('[data-asura-fav-corazon]');
    return plantilla ? plantilla.innerHTML : '';
  }

  function marcas(caja) {
    if (caja._marcas) return caja._marcas;
    var nodo = caja.querySelector('[data-asura-fav-marcas]');
    try {
      caja._marcas = nodo ? JSON.parse(nodo.textContent) : {};
    } catch (e) {
      caja._marcas = {};
    }
    return caja._marcas;
  }

  function tarjeta(caja, p) {
    var pres = presentacion(p.tags);
    var variante = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0] || {};
    var url = raiz + 'products/' + p.handle;
    var marcaUrl = marcas(caja)[p.vendor] || (raiz + 'collections/vendors?q=' + encodeURIComponent(p.vendor || ''));
    var img = p.featured_image
      ? '<img src="' + escapar(foto(p.featured_image, 600)) + '" srcset="' + escapar(foto(p.featured_image, 400)) + ' 400w, ' + escapar(foto(p.featured_image, 600)) + ' 600w, ' + escapar(foto(p.featured_image, 900)) + ' 900w" sizes="(min-width: 769px) 22vw, 46vw" alt="' + escapar(p.title) + '" loading="lazy">'
      : '';

    return '' +
      '<article class="asura-fav-tarjeta' + (p.available ? '' : ' is-vendido') + '" data-handle="' + escapar(p.handle) + '">' +
        '<div class="asura-fav-tarjeta__foto">' +
          '<a href="' + escapar(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<span class="asura-etiqueta asura-etiqueta--tarjeta asura-etiqueta--' + pres.clase + '">' + pres.texto + '</span>' +
          '<button type="button" class="asura-fav asura-fav--tarjeta is-guardado" data-asura-fav data-handle="' + escapar(p.handle) + '" data-nombre="' + escapar(p.title) + '" aria-pressed="true" aria-label="Quitar ' + escapar(p.title) + ' de favoritos" title="Quitar de favoritos">' + corazon(caja) + '</button>' +
        '</div>' +
        '<div class="asura-fav-tarjeta__datos">' +
          (p.vendor ? '<a class="asura-fav-tarjeta__marca" href="' + escapar(marcaUrl) + '">' + escapar(p.vendor) + '</a>' : '') +
          '<a class="asura-fav-tarjeta__nombre" href="' + escapar(url) + '">' + escapar(p.title) + '</a>' +
          '<p class="asura-fav-tarjeta__precio">' + dinero(p.price) + '</p>' +
          (p.available
            ? '<button type="button" class="asura-fav-tarjeta__agregar" data-asura-fav-agregar data-variante="' + escapar(variante.id) + '">Agregar al carrito</button>'
            : '<p class="asura-fav-tarjeta__vendido">' + (pres.clase === 'linea' ? 'Agotado por ahora' : 'Se vendió · ya no tenemos esta pieza') + '</p>') +
        '</div>' +
      '</article>';
  }

  function resumir(caja, n) {
    var r = caja.querySelector('[data-asura-fav-resumen]');
    if (r) r.textContent = n === 1 ? '1 perfume guardado' : n + ' perfumes guardados';
  }

  function vacia(caja, si) {
    var vacio = caja.querySelector('[data-asura-fav-vacio]');
    var rejilla = caja.querySelector('[data-asura-fav-rejilla]');
    if (vacio) vacio.hidden = !si;
    if (rejilla) rejilla.hidden = si;
    var r = caja.querySelector('[data-asura-fav-resumen]');
    if (r) r.hidden = si;
  }

  function armarPagina(caja) {
    var rejilla = caja.querySelector('[data-asura-fav-rejilla]');
    var lista = leer();
    caja._corrida = (caja._corrida || 0) + 1;
    var corrida = caja._corrida;

    if (!lista.length) {
      vacia(caja, true);
      caja.classList.remove('is-cargando');
      return;
    }

    vacia(caja, false);
    resumir(caja, lista.length);
    caja.classList.add('is-cargando');
    rejilla.innerHTML = lista.map(function () {
      return '<div class="asura-fav-tarjeta asura-fav-tarjeta--hueco" aria-hidden="true"><div class="asura-fav-tarjeta__foto"></div><div class="asura-fav-tarjeta__datos"><span></span><span></span><span></span></div></div>';
    }).join('');

    Promise.all(lista.map(function (x) {
      return fetch(raiz + 'products/' + encodeURIComponent(x.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return undefined; });
    })).then(function (productos) {
      if (corrida !== caja._corrida) return;
      // un perfume que ya no existe en la tienda (404) sale de la lista
      var vivos = lista.filter(function (x, i) { return productos[i] !== null; });
      if (vivos.length !== lista.length) {
        escribir(vivos);
        cambio();
      }

      var html = productos.filter(Boolean).map(function (p) { return tarjeta(caja, p); }).join('');
      caja.classList.remove('is-cargando');
      if (!html) {
        vacia(caja, true);
        pintar();
        return;
      }
      rejilla.innerHTML = html;
      resumir(caja, rejilla.querySelectorAll('.asura-fav-tarjeta').length);
      pintar();
    });
  }

  function quitarTarjeta(caja, handle) {
    var t = caja.querySelector('.asura-fav-tarjeta[data-handle="' + handle.replace(/"/g, '') + '"]');
    if (!t) return;
    t.classList.add('is-saliendo');
    setTimeout(function () {
      t.remove();
      var quedan = caja.querySelectorAll('.asura-fav-tarjeta').length;
      if (!quedan) vacia(caja, true);
      else resumir(caja, quedan);
    }, 260);
  }

  // Agregar al carrito desde favoritos: abre el carrito lateral (o la hoja, si la hay)
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-asura-fav-agregar]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var propiedades = {};
    propiedades[DECANT] = SORPRESA;
    b.disabled = true;
    b.classList.add('is-cargando');

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(b.dataset.variante), quantity: 1, properties: propiedades })
    }).then(function (r) {
      return r.json().then(function (datos) { return { ok: r.ok, datos: datos }; });
    }).then(function (res) {
      b.disabled = false;
      b.classList.remove('is-cargando');
      if (!res.ok) {
        var msj = (res.datos && (res.datos.description || res.datos.message)) || 'No se pudo agregar';
        avisar(msj, '');
        return;
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.datos } }));
    }).catch(function () {
      b.disabled = false;
      b.classList.remove('is-cargando');
      avisar('No se pudo agregar, intenta de nuevo', '');
    });
  });

  function arrancar() {
    window.asuraFavoritos.leer = leer;
    window.asuraFavoritos.guardado = guardado;
    sincronizar();
    pintar();
    document.querySelectorAll('[data-asura-favoritos]').forEach(armarPagina);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
